import cuckoo, { EventProps } from "@kiwicom/frontend-common/services/cuckoo/cuckoo"

import { TrackingEvent } from "./constants/trackingEventTypes"

export type MmbTrack = (arg1: TrackingEvent, arg2: EventProps) => void

/**
 * @typedef {import("@kiwicom/nitro/lib/services/log/logger").log} log
 * @typedef {import("@kiwicom/nitro/lib/services/log/context").useLog} useLog
 *
 * @deprecated use {@link createEventLogUnified} together with Nitro's
 * {@link useLog} (in React components) or {@link log} (outside React
 * components) instead.
 */
export default ({ module, action, detail }: TrackingEvent, props?: EventProps) => {
  cuckoo.track(
    {
      category: module,
      ...action,
      detail: detail ?? "",
    },
    props,
  )
}
